import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ROUTING_CALENDARIO_PAGO_PENSION } from '../shared/common/constants/url.constant';
import { CalendarioPagoPensionHomeComponent } from "./pages/calendario-pago-pension-home/calendario-pago-pension-home.component";

const CALENDARIO_PAGO_PENSION_ROUTES: Routes = [
  {
    path: "",
    redirectTo: ROUTING_CALENDARIO_PAGO_PENSION.CALENDARIO_PAGO_PENSION_HOME,
    pathMatch: "full",
  },
  {
    path: ROUTING_CALENDARIO_PAGO_PENSION.CALENDARIO_PAGO_PENSION_HOME,
    component: CalendarioPagoPensionHomeComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(CALENDARIO_PAGO_PENSION_ROUTES)],
  exports: [RouterModule],
})
export class CalendarioPagoPensionRoutingModule {}
